import React from 'react'
import SubscriptionPage from '../SubscriptionPage'

export default function AssetsPage() {
  return (
    <div>
    <SubscriptionPage />
  </div>
  )
}
